import type { FunctionComponent } from "react"

import Image from "next/image"

import { InsightCard } from "@jobteaser/ui-kit/components/Card/cardComponents/InsightCard/InsightCard"

import defaultSchoolLogo from "@/modules/corporate/images/default-school-logo.png"
import { getAssetImportUrl } from "@/modules/staticAssets/getAssetImportUrl"

import styles from "./Network.module.css"

type NetworkCardPropsType = {
  title: string
  country: string
  schoolType: string
  logoSrc?: string
  useType: boolean
}

export const NetworkCard: FunctionComponent<NetworkCardPropsType> = ({
  title,
  country,
  schoolType,
  logoSrc,
  useType,
}) => (
  <InsightCard
    jobInfos={[country]}
    studentInfos={useType ? [schoolType] : []}
    title={title}
    avatarProps={{
      className: styles.image,
      component: Image,
      height: 256,
      sizes: "25vw",
      width: 256,
    }}
    avatarSrc={logoSrc || getAssetImportUrl(defaultSchoolLogo)}
    linkProps={{ as: "span" }}
  />
)
